import { JsonQuery, TJsonQuery } from '../../../packages/JsonQuery';
import { EMetroTravelType, IJsonQueryUnderground } from '../../../packages/api-models/common/json_query';
import { setUndergroundTravel } from '../../../packages/JsonQuery/setUndergroundTravel';
import { getDefaultTravelTimeForType } from '../underground';
import { IStationData } from 'shared/types/geo';

export function addUndergroundsToJsonQuery(jsonQuery: TJsonQuery, stations: IStationData[]) {
  let nextJsonQuery = new JsonQuery(jsonQuery).toJSON();

  const undergrounds: IJsonQueryUnderground[] = stations.reduce((acc: IJsonQueryUnderground[], item) => {
    acc.push({
      type: 'underground',
      id: Number(item.id),
    });

    return acc;
  }, []);

  const wasNoUndergrounds = !nextJsonQuery.geo || !nextJsonQuery.geo.value.some(geo => geo.type === 'underground');
  const wasNoTravelType = !nextJsonQuery.only_foot || !nextJsonQuery.only_foot.value;
  const wasNoTravelTime = !nextJsonQuery.foot_min || !nextJsonQuery.foot_min.value;

  if (wasNoUndergrounds && wasNoTravelTime && wasNoTravelType) {
    nextJsonQuery = setUndergroundTravel(nextJsonQuery)(
      EMetroTravelType.MapFoot,
      getDefaultTravelTimeForType(EMetroTravelType.MapFoot),
    );
  }

  return {
    ...nextJsonQuery,
    geo: {
      type: 'geo',
      value: nextJsonQuery.geo ? nextJsonQuery.geo.value.concat(undergrounds) : undergrounds,
    },
  };
}
